/* global G */
import { getRefKeys, getUrl, insertMessage, noLoaderMiddleware } from '@platform/adapter/message/helper'
import { defaultMiddleware } from 'platform/adapter/http/middleware'

/**
 * Adds a message to the adapter's G.DATA list of messages, dispatches a G.DONE event and then
 * attempts to send it to the server. The message's key is generated client-side, so its
 * attachments can be uploaded while it is being created. On successful send, it sets the new
 * message's rev, value, refs and acl and dispatches a G.DONE event again.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 */
const fn = app => async ({ detail }) => {
  const adapter = app[G.ADAPTER][G.MESSAGE]
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapterData = adapter[G.DATA]
  const { draft, ...item } = detail[G.DATA]
  const hasAttachments = detail[G.ATTACHMENT]
  const callback = detail[G.FN]

  insertMessage(adapterData, item)

  /**
   * Why do we dispatch the same event here and then later below?
   * Because we want to show the message in the chat window already while
   * it's sending to the server with the 'Sending...' footer.
   */
  eventBus.dispatch(eventBus.type(G.MESSAGE, G.DONE), { [G.DATA]: adapterData })

  const url = `${getUrl(app)}/default`
  const { key, ...params } = item
  
  const result = await app[G.ADAPTER][G.HTTP][G.API].post({
    url,
    params: { ...params, _id: key },
  }, {
    middleware: hasAttachments
      ? noLoaderMiddleware
      : defaultMiddleware,
  })

  if (result) {
    const { data = result } = result
    const { attachments } = item.value || {}

    item.key = data.key
    item._rev = data._rev
    item.value = { ...data.value, ...attachments && { attachments } }
    item.refs = getRefKeys(data.refs)
    item.acl = data.acl

    await callback?.(item)

    eventBus.dispatch(eventBus.type(G.MESSAGE, G.DONE), { [G.DATA]: adapterData })
  }
}

export default fn
